import {types} from '../../types';

const setGetHistoryListAction = (payload) => {
    return {
        type: types.report.SET_HISTORY_LIST,
        payload,
      }
}

export {
  setGetHistoryListAction as SetGetHistoryListAction
}